// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".module-block{margin:0 auto;max-width:var(--max-content-width);padding:30px;position:relative;--radius:20px}.module-block__color-bg,.module-block__image,.module-block__mobile-image{border-radius:20px;bottom:0;left:0;pointer-events:none;position:absolute;right:0;top:0}.module-block__content{margin:0 auto}.module-block.is-moble{border-radius:10px;padding:10px 5px}.module-block.no-padding{padding:0!important}.stand-alone-mode .module-block{border-radius:var(--radius);box-shadow:0 0 10px rgba(0,0,0,.2);position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteFontFamily": "system-ui,sans-serif,math,ui-rounded,ui-monospce"
};
module.exports = ___CSS_LOADER_EXPORT___;
